import { render } from "./WebsitesAvailableModal.vue?vue&type=template&id=2f54bc49&scoped=true"
import script from "./WebsitesAvailableModal.vue?vue&type=script&lang=ts"
export * from "./WebsitesAvailableModal.vue?vue&type=script&lang=ts"

import "./WebsitesAvailableModal.vue?vue&type=style&index=0&id=2f54bc49&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f54bc49"

export default script